import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { push, replace } from "connected-react-router";
import qs from "query-string";
import ROUTES from "../../../routes";
import {
  BoxMenu,
  BoxSeparator,
  ContentBox,
  FiltersContainer,
  FiltersSelector,
  BranchesSelector,
  FiltersSeparator,
  FiltersText,
  EmptyMessage,
  ForbiddenSection,
  Page,
  OperationsTable,
  TitleBox,
  Button,
  FiltersDateSelector,
} from "../../../components";
import moment from "moment";
import {
  Visibility as VisisbilityIcon,
  SaveAlt as SaveAltIcon,
} from "@material-ui/icons";
import { business as businessActions } from "../../../actions";
import MoreVerticalIcon from "../../../static/images/icons/more_vertical.svg";
import { Language, Utils } from "../../../utils";
import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { toISOString } from "../../../utils/Utils";
import makeClasses from "./styles";
import {
  CUSTOM_FILTER,
  getDateRangeForFilter,
} from "../../../components/FiltersDateSelector";
import { Policies } from "../../../utils/Policies";
import _ from "lodash";

const IncompleteSuscriptionsScreen = ({ history }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();
  const searchParams = qs.parse(history.location.search);
  const [paginationPage, setPaginationPage] = useState(
    searchParams.page ? parseInt(searchParams.page) : 1
  );
  const [forbiddenSection, setForbbidenSection] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(searchParams.pid || "all");
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [plansOptions, setPlansOptions] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(
    searchParams.bid || "all"
  );
  const [subscriberDocument, setSubscriberDocument] = useState(
    searchParams.document || ""
  );
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuOpenIndex, setMenuOpenIndex] = useState(-1);
  const [incompleteSubscriptions, setIncompleteSubscriptions] = useState(null);
  const [filtersLoaded, setFiltersLoaded] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(
    searchParams.fid
      ? searchParams.fid === "custom"
        ? searchParams.fid
        : parseInt(searchParams.fid)
      : 0
  );
  const [selectedCustomFilter, setSelectedCustomFilter] = useState(
    searchParams.fid === CUSTOM_FILTER
      ? { startDate: searchParams.fsd, endDate: searchParams.fed }
      : {}
  );
  const { policies, languageTexts } = useSelector((state) => ({
    policies: state.user.userData.policies || [],
    languageTexts: state.language.texts || {},
  }));
  const [selectedSubscriber, setSelectedSubscriber] = useState(
    searchParams.sid || "all"
  );
  const i18n = Language(languageTexts);
  const canSeeTransactions = policies.includes(
    Policies.types.PROVIDERS_SUBSCRIPTIONS_TRANSACTIONS
  );
  const canExport = policies.includes(Policies.types.SUPER_READ);

  const STEP_VALUES = {
    PERSONAL_DATA: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Steps.PersonalData"
    ),
    PAYMENT: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Steps.Payment"
    ),
    PERSONAL_DATA_COMPLETED: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Steps.PersonalDataCompleted"
    ),
  };

  const REASON_VALUES = {
    POS_IS_INACTIVE: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PosIsInactive"
    ),
    SUBSCRIPTION_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriptionDoesNotExist"
    ),
    PURCHASE_FAILED_AT_PLEXO: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexo"
    ),
    PURCHASE_FAILED_AT_PLEXO_INSUFFICIENT_FUNDS: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexoInsufficientFunds"
    ),
    SUBSCRIBER_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriberDoesNotExist"
    ),
    SUBSCRIPTION_PLAN_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriptionPlanDoesNotExist"
    ),
    SUBSCRIPTION_PLAN_INACTIVE: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriptionPlanInactive"
    ),
    SUBSCRIPTION_ALREADY_CANCELLED: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriptionAlreadyCancelled"
    ),
    BRANCH_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.BranchDoesNotExist"
    ),
    BRANCH_DOES_NOT_HAVE_POS_BY_DEFAULT: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.BranchDoesNotHavePosByDefault"
    ),
    ERROR_DEACTIVATING_INSTRUMENT: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.ErrorDeactivatingInstrument"
    ),
    BRANCH_IS_NOT_ACTIVE: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.BranchIsNotActive"
    ),
    BRANCH_DONT_HAVE_TYC: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.BranchDontHaveTyc"
    ),
    SUBSCRIBER_ALREADY_HAS_SUBSCRIPTION_PLAN: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.SubscriberAlreadyHasSubscriptionPlan"
    ),
    ADDITIONAL_FIELD_DOES_NOT_EXIST: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.AdditionalFieldDoesNotExist"
    ),
    ADDITIONAL_FIELD_WRONG_TYPE: i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.AdditionalFieldWrongType"
    ),
  };

  function getErrorMessage(subscription) {
    const isPlexoError =
      subscription.failureReason === "PURCHASE_FAILED_AT_PLEXO";

    if (!isPlexoError) {
      return REASON_VALUES[subscription.failureReason];
    }

    if (subscription.errorCode === 51 || subscription.errorCode === 3003) {
      return i18n.get(
        "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexoInsufficientFunds"
      );
    }
    if (subscription.errorCode === 5 || subscription.errorCode === 3001) {
      return i18n.get(
        "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexoCardDeclined"
      );
    }
    if (subscription.errorCode === -1) {
      return i18n.get(
        "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexoPendingTransaction"
      );
    }
    return i18n.get(
      "ProvidersSubscriptionIncompleteSubscriptions.Reasons.PurchaseFailedAtPlexo"
    );
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      policies &&
      policies.includes(Policies.types.PROVIDERS_SUBSCRIPTIONS_PROMOTIONS)
    ) {
      loadFiltersData();
      loadAttempts();
    } else {
      setForbbidenSection(true);
    }
  }, [
    policies,
    subscriberDocument,
    paginationPage,
    selectedBranch,
    selectedFilter,
    selectedPlan,
    selectedSubscriber,
    selectedCustomFilter,
  ]);

  const loadAttempts = () => {
    const dateFilter = getDateRangeForFilter(
      selectedFilter,
      selectedFilter === CUSTOM_FILTER ? selectedCustomFilter : null,
      true
    );
    const startDate = toISOString(dateFilter.startDate);
    let endDate = toISOString(dateFilter.endDate);

    if (startDate && endDate && startDate === endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      endDate = toISOString(end);
    }

    dispatch(
      businessActions.getProvidersSubcriptionAttemps(
        selectedBranch !== "all" ? selectedBranch : null,
        subscriberDocument ? subscriberDocument : null,
        selectedPlan !== "all" ? selectedPlan : null,
        startDate,
        endDate,
        paginationPage,
        15,
        (data) => {
          setIncompleteSubscriptions(data);
        }
      )
    );
  };

  const loadFiltersData = () => {
    if (filtersLoaded) {
      return;
    }
    dispatch(
      businessActions.getProvidersSubscriptionsMerchant((branches) => {
        setBranches(
          branches.branches
            ?.filter((b) => b.serviceStatus === "ACTIVE")
            ?.map((b) => ({ traceId: b.branchId, name: b.name })) || []
        );
      })
    );
    dispatch(
      businessActions.getProvidersSubscriptionsPlans(
        null,
        null,
        null,
        null,
        null,
        100,
        null,
        (data) => {
          if (data) {
            const options = data.elements
              ? data.elements
                  .filter((e) => e)
                  .map((e) => ({
                    id: e.subscriptionPlanTraceId,
                    name: e.name,
                    frequence: e.frequence,
                  }))
              : [];
            setPlansOptions(options);
          }
        }
      )
    );

    setFiltersLoaded(true);
  };

  const handleOnPaginationChange = (nextPage) => {
    setPaginationPage(nextPage);

    const searchParams = qs.parse(history.location.search) || {};
    searchParams.page = nextPage;

    dispatch(
      replace({
        search: qs.stringify(searchParams),
      })
    );
  };

  const handleOnFilterSelected = (filter, startDate, endDate) => {
    setSelectedFilter(filter);
    handleOnPaginationChange(1);

    const searchParams = qs.parse(history.location.search) || {};
    searchParams.fid = filter;

    if (filter === CUSTOM_FILTER) {
      setSelectedCustomFilter({ startDate, endDate });
      searchParams.fsd = startDate;
      searchParams.fed = endDate;
    }

    dispatch(
      replace({
        search: qs.stringify(searchParams),
      })
    );
  };

  const handleOnBranchSelected = (branch) => {
    setSelectedBranch(branch);
    handleOnPaginationChange(1);

    const searchParams = qs.parse(history.location.search) || {};
    searchParams.bid = branch;

    dispatch(
      replace({
        search: qs.stringify(searchParams),
      })
    );
  };

  const renderBranchesSelector = () => (
    <BranchesSelector
      branches={branches}
      selectedBranch={selectedBranch}
      onBranchSelected={handleOnBranchSelected}
    />
  );

  const handleOnPlanSelected = (plan) => {
    setSelectedPlan(plan);
    handleOnPaginationChange(1);

    const searchParams = qs.parse(history.location.search) || {};
    searchParams.pid = plan;

    dispatch(
      replace({
        search: qs.stringify(searchParams),
      })
    );
  };

  const handleOnMenuItemClick = (item) => {
    dispatch(push(item.path));
  };

  const handleOnSubscriberDocumentChange = (document) => {
    setSubscriberDocument(document);
    const searchParams = qs.parse(history.location.search) || {};

    searchParams.document = document;
    searchParams.page = 1;
    setPaginationPage(1);
    if (document.length === 0) {
      searchParams.sid = "all";
      setSelectedSubscriber("all");
      dispatch(
        replace({
          search: qs.stringify(searchParams),
        })
      );
      return;
    }
    dispatch(
      replace({
        search: qs.stringify(searchParams),
      })
    );
  };

  const toggleMenu = (index) => (e) => {
    if (menuAnchorEl) {
      setMenuAnchorEl(null);
      setMenuOpenIndex(-1);
    } else {
      setMenuAnchorEl(e.target);
      setMenuOpenIndex(index);
    }
  };

  const handleOnViewIncompleteSubscription = (subscription) => () => {
    toggleMenu()();
    dispatch(
      push(
        ROUTES.INCOMPLETE_SUBSCRIPTIONS_DETAIL.path.replace(
          ":traceId",
          subscription.subscriptionAttemptId
        ),
        { subscription }
      )
    );
  };

  const renderSubscriptions = () => {
    if (
      !incompleteSubscriptions ||
      !incompleteSubscriptions.elements ||
      incompleteSubscriptions.elements.length === 0
    ) {
      return (
        <EmptyMessage textOnly>
          {i18n.get("ProvidersSubscriptionsManagePromotions.GridEmptyMessage")}
        </EmptyMessage>
      );
    }

    const headers = [
      {
        canHide: false,
        columnNumber: 1,
        name: i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.Columns.Date"
        ),
        sortable: false,
        type: "date",
      },
      {
        canHide: false,
        columnNumber: 2,
        name: i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.Columns.Plan"
        ),
        sortable: false,
        type: "text",
      },
      {
        canHide: false,
        columnNumber: 3,
        name: i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.Columns.Step"
        ),
        sortable: false,
        type: "text",
      },
      {
        canHide: false,
        columnNumber: 4,
        name: i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.Columns.Subscriber"
        ),
        sortable: false,
        type: "text",
      },
      {
        canHide: false,
        columnNumber: 5,
        name: i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.Columns.Phone"
        ),
        sortable: false,
        type: "text",
      },
      {
        canHide: false,
        columnNumber: 6,
        name: i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.Columns.Email"
        ),
        sortable: false,
        type: "text",
      },
      {
        canHide: false,
        columnNumber: 7,
        name: i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.Columns.Reason"
        ),
        sortable: false,
        type: "text",
      },
      {
        canHide: false,
        columnNumber: 8,
        name: i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.Columns.Actions"
        ),
        sortable: false,
        type: "custom",
        show: !isSm,
        align: "right",
      },
    ];
    const body = (incompleteSubscriptions.elements || [])
      .filter((item) => !item.promotionPostpone)
      .map((item, index) => ({
        rowId: item.traceId,
        columns: [
          {
            columnNumber: 1,
            data: item.createdAt,
          },
          {
            columnNumber: 2,
            data: item.subscriptionPlan?.name,
          },
          {
            columnNumber: 3,
            data: STEP_VALUES[item.attemptStep],
          },
          {
            columnNumber: 4,
            data: `${item.subscriber?.document} - ${item.subscriber?.firstName} ${item.subscriber?.lastName}`,
          },
          {
            columnNumber: 5,
            data: `(${item.subscriber?.phoneCallingCode}) ${item.subscriber?.phoneNumber}`,
          },
          {
            columnNumber: 6,
            data: item.subscriber?.email,
          },
          {
            columnNumber: 7,
            data: getErrorMessage(item),
          },
          {
            columnNumber: 8,
            data: () => {
              return (
                <div className={classes.listItemActions}>
                  <IconButton onClick={toggleMenu(index)}>
                    <img src={MoreVerticalIcon} alt="More" />
                  </IconButton>
                  <Menu
                    anchorEl={menuAnchorEl}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    keepMounted
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    onClose={toggleMenu()}
                    open={menuOpenIndex === index}
                    className={classes.listItemMenu}>
                    <MenuItem
                      onClick={handleOnViewIncompleteSubscription(item)}
                      className={classes.listItemMenuItem}>
                      <ListItemIcon className={classes.menuItemIcon}>
                        <VisisbilityIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={i18n.get(
                          "ProvidersSubscriptionsManagePromotions.ActionViewDetails"
                        )}
                        className={classes.menuItemText}
                      />
                    </MenuItem>
                  </Menu>
                </div>
              );
            },
          },
        ],
      }));

    return (
      <OperationsTable
        headers={headers}
        body={body}
        currentPage={paginationPage}
        paginationSimple
        hasMorePages={incompleteSubscriptions.hasNext}
        onPaginationChange={handleOnPaginationChange}
        emptyMessage={i18n.get(
          "ProvidersSubscriptionsManagePromotionsView.GridEmptyMessage"
        )}
        showDetails={false}
      />
    );
  };

  const renderPlansSelector = () => {
    return (
      <FiltersSelector
        options={plansOptions}
        selected={selectedPlan}
        onSelected={handleOnPlanSelected}
        defaultOption={i18n.get(
          "ProvidersSubscriptionsManagePromotions.FilterPlansDefaultOption"
        )}
      />
    );
  };

  const renderSubscribersFilter = () => {
    return (
      <FiltersText
        value={subscriberDocument}
        placeholder={i18n.get(
          "ProvidersSubscriptionsManageSubscriptions.FilterSubscribersDocumentPlaceholder"
        )}
        onChange={handleOnSubscriberDocumentChange}
      />
    );
  };

  const renderFiltersDateSelector = () => (
    <FiltersDateSelector
      selectedFilter={selectedFilter}
      startDate={selectedCustomFilter.startDate}
      endDate={selectedCustomFilter.endDate}
      onFilterSelected={handleOnFilterSelected}
      align="right"
      dateFormat={i18n.get("DateFormat", false)}
      showNoFilterOption
      limitToThreeMonths={false}
    />
  );

  const renderExportButton = () => {
    return (
      canExport && (
        <Button
          leftIcon={() => <SaveAltIcon fontSize="small" />}
          onClick={handleOnExport}
          disabled={
            !incompleteSubscriptions ||
            !incompleteSubscriptions.elements ||
            incompleteSubscriptions.elements.length === 0
          }>
          {isSm
            ? null
            : i18n.get("ProvidersSubscriptionsManagePlans.ExportButton")}
        </Button>
      )
    );
  };

  const handleOnExport = () => {
    const dateFilter = getDateRangeForFilter(
      selectedFilter,
      selectedFilter === CUSTOM_FILTER ? selectedCustomFilter : null,
      true
    );
    const startDate = toISOString(dateFilter.startDate);
    let endDate = toISOString(dateFilter.endDate);

    if (startDate && endDate && startDate === endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      endDate = toISOString(end);
    }

    dispatch(
      businessActions.exportProvidersSubcriptionAttemps(
        selectedBranch !== "all" ? selectedBranch : null,
        subscriberDocument ? subscriberDocument : null,
        selectedPlan !== "all" ? selectedPlan : null,
        startDate,
        endDate,
        paginationPage,
        (file) => {
          if (file) {
            Utils.downloadFile(file, getFileName(dateFilter));
          }
        }
      )
    );
  };

  const getFileName = (dateFilter) => {
    if (dateFilter.startDate && dateFilter.endDate) {
      return (
        "Cobranzas_Suscripciones_Subscripciones_" +
        dateFilter.startDate.format(i18n.get("ExportDateFormat")) +
        "_" +
        dateFilter.endDate.format(i18n.get("ExportDateFormat")) +
        ".xlsx"
      );
    }

    return "Cobranzas_Suscripciones_Subscripciones.xlsx";
  };

  if (forbiddenSection) {
    return (
      <Page
        withHeader
        withSidebar
        withHeaderTitle={i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.Title"
        )}
        withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}
        withBanner={false}>
        <ForbiddenSection />
      </Page>
    );
  }

  return (
    <Page
      withHeader
      withSidebar
      withHeaderTitle={i18n.get(
        "ProvidersSubscriptionIncompleteSubscriptions.Title"
      )}
      withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}>
      <BoxMenu
        items={_.compact([
          {
            ...ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_PLANS,
            label: i18n.get(
              "ProvidersSubscriptionsManagePromotions.BoxMenu.Item1"
            ),
          },
          {
            ...ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_PROMOTIONS,
            label: i18n.get(
              "ProvidersSubscriptionsManagePromotions.BoxMenu.Item3"
            ),
          },
          {
            ...ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_SUBSCRIPTIONS,
            label: i18n.get(
              "ProvidersSubscriptionsManagePromotions.BoxMenu.Item2"
            ),
          },
          canSeeTransactions
            ? {
                ...ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_TRANSACTIONS,
                label: i18n.get(
                  "ProvidersSubscriptionsManagePromotions.BoxMenu.Item4"
                ),
              }
            : null,
          {
            ...ROUTES.INCOMPLETE_SUBSCRIPTIONS,
            label: i18n.get(
              "ProvidersSubscriptionsManagePromotions.BoxMenu.Item6"
            ),
          },
          {
            ...ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_TERMS_AND_CONDITIONS,
            label: i18n.get(
              "ProvidersSubscriptionsManagePromotions.BoxMenu.Item5"
            ),
          },
        ])}
        selectedItem={ROUTES.INCOMPLETE_SUBSCRIPTIONS.id}
        onClickItem={handleOnMenuItemClick}
      />
      <TitleBox
        title={i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.BoxTitle"
        )}
      />
      <BoxSeparator size="small" />
      <ContentBox
        title={i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.BoxFiltersTitle"
        )}>
        <FiltersContainer>
          {renderBranchesSelector()}
          <FiltersSeparator />
          {renderPlansSelector()}
          <FiltersSeparator />
          {renderSubscribersFilter()}
          <FiltersSeparator />
          {renderFiltersDateSelector()}
        </FiltersContainer>
      </ContentBox>
      <BoxSeparator size="small" />
      <ContentBox
        title={i18n.get(
          "ProvidersSubscriptionIncompleteSubscriptions.GridTitle"
        )}
        titleBold
        customRightAction={renderExportButton}>
        {incompleteSubscriptions &&
        incompleteSubscriptions?.elements?.length > 0 ? (
          renderSubscriptions()
        ) : (
          <div className={classes.noDataMessage}>
            {i18n.get(
              "ProvidersSubscriptionsManagePromotions.NoSubscribersMessage"
            )}
          </div>
        )}
      </ContentBox>
    </Page>
  );
};

IncompleteSuscriptionsScreen.id = "com.Handy.IncompleteSuscriptions";

export default IncompleteSuscriptionsScreen;
